import { render, staticRenderFns } from "./shopExchangeSet.vue?vue&type=template&id=64ef7ff0&scoped=true"
import script from "./shopExchangeSet.vue?vue&type=script&lang=js"
export * from "./shopExchangeSet.vue?vue&type=script&lang=js"
import style0 from "./shopExchangeSet.vue?vue&type=style&index=0&id=64ef7ff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef7ff0",
  null
  
)

export default component.exports